import React, { useState } from "react";
import { Button, Modal, Result } from "antd";
import { history } from "@umijs/max";
import { emitMyTimeOffRequested, requestMyTimeOff } from "@/services/app/tenant/technician-availability";
import TimeOffFormModal from "../../Users/components/TimeOffFormModal";

interface RequestTimeOffModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Request Time Off from the profile menu: the My Availability request form,
 * then a confirmation with a shortcut to My Availability (where the request's
 * status shows and it can be cancelled while pending).
 */
const RequestTimeOffModal: React.FC<RequestTimeOffModalProps> = ({ open, onOpenChange }) => {
  const [sent, setSent] = useState(false);

  return (
    <>
      <TimeOffFormModal
        open={open}
        onOpenChange={onOpenChange}
        isSelf
        onSave={async (payload) => {
          await requestMyTimeOff(payload);
          emitMyTimeOffRequested();
          setSent(true);
        }}
      />
      <Modal open={sent} onCancel={() => setSent(false)} footer={null} destroyOnHidden>
        <Result
          status="success"
          title="Request sent"
          subTitle="It's pending until a manager approves it. You'll get a notification when it's approved or declined."
          extra={[
            <Button
              key="my-availability"
              type="primary"
              onClick={() => {
                setSent(false);
                history.push("/tenant/my-availability");
              }}
            >
              Go to My Availability
            </Button>,
            <Button key="close" onClick={() => setSent(false)}>
              Close
            </Button>,
          ]}
        />
      </Modal>
    </>
  );
};

export default RequestTimeOffModal;
